// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Turkmenistan from '../_raw/flag/icon_flag_turkmenistan.png';

export default () => <img src={Turkmenistan} alt="Turkmenistan" />;
